import React from 'react'

export default function Footer() {
  return (
    <>
              <a href="#footer" data-scroll-to>
            <h1>FOOTER</h1>
          </a>

          
    
    </>
  )
}
